import axios from 'axios';
import { handleLanguageHotReload } from 'src/services/i18n.service';
import { initGA4 } from './services/tracking.service';
import { runExternalScripts } from './utils/externals';

axios.get('/config.json').then(({ data }) => {
  window.config = data;
  runExternalScripts();
  handleLanguageHotReload();
  initGA4();
  import('src/bootstrap');
});
